import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SidebarModule } from '../sidebar/sidebar.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ErrorModule } from 'src/app/core/error/error.module';
import {MatSidenavModule} from '@angular/material/sidenav';
import { LoadingAnimationModule } from "../../core/loading-animation/loading-animation.module";
import { BreadCrumbsModule } from "src/app/core/bread-crumbs/bread-crumbs.module";


@NgModule({
  declarations: [
    HomeComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    HeaderModule,
    FooterModule,
    SidebarModule,
    DashboardModule,
    ErrorModule,
    MatSidenavModule,
    LoadingAnimationModule,
    BreadCrumbsModule
],

})
export class HomeModule { }
